import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgErrorCircle32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><circle cx={16} cy={16} r={16} fill="#D0021B" /><path fill="#fff" d="M8.667 14v4h14.666v-4z" /></SvgIcon>;
};
const Memo = memo(SvgErrorCircle32);
export default Memo;